import axios from 'axios';
import { API_PATH } from 'config';
import { getCurrentSubdomain } from './tenantResolver';

// Cliente público: NO usa el axios autenticado (no hay token; el visitante es
// anónimo). Sí manda X-Tenant-Subdomain para que el backend resuelva el tenant.
//
// Nota: getCurrentSubdomain vive en api/tenantResolver (no en utils/handlers).
const headers = () => ({ 'X-Tenant-Subdomain': getCurrentSubdomain() });

export const getEquipoPublico = (token) =>
  axios.get(`${API_PATH}/public/equipos/${token}`, { headers: headers() }).then((r) => r.data);

export const reportarFallaPublica = (token, body) =>
  axios
    .post(`${API_PATH}/public/equipos/${token}/reporte`, body, { headers: headers() })
    .then((r) => r.data);
